import React, { useContext, useState } from "react";
import { useEffect } from "react";
import cfe from "../../../services/cfe";
import AppContext from "../../../container/context";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../../components/table/ActionTable";
import { mergeParams } from "../../../helpers/helpers";
import Form from "../../../components/form";

export default function Lista({ history, location }) {
  const { notification } = useContext(AppContext);
  const [tokens, setTokens] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [instituicoes, setInstituicoes] = useState([]);
  const [dados, setDados] = useState(
    mergeParams(
      {
        nome: "",
        email: "",
        instituicaoId: 0,
      },
      location
    )
  );

  useEffect(() => {
    if (dados.nome || dados.email || dados.instituicaoId) {
      carregar();
    }
    carregarInstituicoes();
  }, []);

  const carregar = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);

    cfe
      .get("admin/tokensCadastro/listar", filtrosEnviar)
      .then((tokens) => {
        tokens.forEach((token) => {
          token.geracao = new Date(token.geracao).toLocaleDateString("pt-BR");
          token.expiracao =
            token.expiracao &&
            new Date(token.expiracao).toLocaleDateString("pt-BR");
        });
        setCarregando(false);
        setTokens(tokens);
      })
      .catch((e) => notification("error", "Erro ao listar os profissionais"));
  };

  const carregarInstituicoes = () => {
    cfe
      .get("admin/instituicoes/listar")
      .then((res) => {
        setInstituicoes(res);
      })
      .catch((e) => notification("error", "Erro ao listar os instituições"));
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 4,
        value: dados.nome,
      },
      email: {
        type: "text",
        label: "Email",
        space: 4,
        value: dados.email,
      },
      instituicaoId: {
        label: "Instituição",
        space: 4,
        value: dados.instituicaoId,
        type: "select",
        emptyItem: true,
        array: {
          data: instituicoes,
          value: "id",
          desc: "nomeFantasia",
        },
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    history,
    // location,
  };

  const tRegistros = {
    title: "Tokens",
    newItemAction: () => history.push("/app/tokens-cadastro/inserir"),
    onLineClick: (id) =>
      history.push(`/app/tokens-cadastro/editar/${id.codigo}`),
    columns: [
      {
        label: "Gerado para",
        name: "usuarioNome",
      },
      {
        label: "Instituição",
        name: "instituicaoNomeFantasia",
      },
      {
        label: "Gerado em",
        name: "geracao",
      },
      {
        label: "Utilizado em",
        name: "utilizacao",
      },
      {
        label: "Expira em",
        name: "expiracao",
      },
    ],
    array: tokens,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
